export default __webpack_public_path__ + "static/media/flag-italy-active.bb4c8af4.svg";